export default "__VITE_ASSET__ed602696__"